/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Upload_DocumentInputs */

const en_dashboard_upload_document = /** @type {(inputs: Dashboard_Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a document`)
};

const es_dashboard_upload_document = /** @type {(inputs: Dashboard_Upload_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir un documento`)
};

/**
* | output |
* | --- |
* | "Upload a document" |
*
* @param {Dashboard_Upload_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_upload_document = /** @type {((inputs?: Dashboard_Upload_DocumentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Upload_DocumentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_upload_document(inputs)
	return en_dashboard_upload_document(inputs)
});